// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bfAAEpEQlIV7WC {
  flex: 0 0 36px;
}
.bfAAEpEQlIV7WC.rTcWFYOEu1rHbS {
  flex: 0 0 auto;
}
`, ""]);
// Exports
export var boardSwitcherButton = `bfAAEpEQlIV7WC`;
export var withLabel = `rTcWFYOEu1rHbS`;
export default ___CSS_LOADER_EXPORT___;
